import { useEffect } from 'react'

import type { OrderConfirmationAppliedDiscountData } from '@library/api-customer-engagement-experience'

import { trackAppliedDiscountShown } from './appliedDiscountTracking'

// Module-level so a remount, or a second instance, for the same order in one page load does not
// send the event again.
const trackedOrderIds = new Set<string>()

/**
 * Sends the xAPI's display event once per order per page load, when the applied discount badge is
 * actually shown. Pass undefined when it is not shown.
 */
export const useTrackAppliedDiscountShown = (
  orderId: string,
  appliedDiscount: OrderConfirmationAppliedDiscountData | undefined,
) => {
  const analytics = appliedDiscount?.analytics

  useEffect(() => {
    if (!orderId || !analytics || trackedOrderIds.has(orderId)) {
      return
    }

    trackedOrderIds.add(orderId)
    trackAppliedDiscountShown(analytics)
  }, [orderId, analytics])
}
